import React, { FC } from 'react'
import { useHistory } from 'react-router'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { IShipmentBid } from 'types'
import { RefreshIcon } from 'transfix-icons'
import { Button } from 'transfix-ui'
import { formatCurrency } from 'utils/formatCurrency'

export interface ICounterOfferDetailsProps {
  shipmentId?: number
  bid: IShipmentBid
  compact?: boolean
  onClick: () => void
  carrierIdForBid?: number
}

const useCounterOfferStyles = makeStyles(theme => ({
  counterOfferIcon: {
    backgroundColor: brandColors.skyBlue2,
    padding: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadius * 2,
    color: brandColors.skyBlue7,
  },
  counterOfferButton: {
    backgroundColor: 'transparent',
  },
  counterOfferText: {
    color: brandColors.coolGray8,
  },
}))

export const CounterOfferDetails: FC<ICounterOfferDetailsProps> = ({
  bid,
  carrierIdForBid,
  compact,
  onClick,
  shipmentId,
}) => {
  const { counterBidAmount } = bid || {}

  const classes = useCounterOfferStyles()
  const history = useHistory()

  const acceptCounterOfferHandler = () => {
    onClick()
    if (carrierIdForBid) {
      history.push(`/book/${shipmentId}/rate-confirmation?carrierId=${carrierIdForBid}`)
    } else {
      history.push(`/book/${shipmentId}/rate-confirmation`)
    }
  }

  const acceptButton = (
    <Button
      data-test='counter-offer-details--accept-button'
      fullWidth={compact}
      color='secondary'
      className={classes.counterOfferButton}
      onClick={acceptCounterOfferHandler}>
      Accept Counter Offer
    </Button>
  )

  return (
    <Box>
      <Box pb={compact ? 2 : 0} display='flex' alignItems='center' justifyContent='space-between'>
        <Box display='flex' alignItems='center'>
          <RefreshIcon size='xlarge' className={classes.counterOfferIcon} />
          <Box pl={1}>
            <Typography className={classes.counterOfferText} variant='subtitle2'>
              {compact ? 'Counter Offer' : `Counter Offer: ${formatCurrency(counterBidAmount)}`}
            </Typography>
          </Box>
        </Box>
        {compact && (
          <Typography data-test='counter-offer-details--amount' variant='subtitle1'>
            {formatCurrency(counterBidAmount)}
          </Typography>
        )}
        {!compact && acceptButton}
      </Box>
      {compact && acceptButton}
    </Box>
  )
}
